
export const setActivePartner = partner => (dispatch) => {
  dispatch({
    type: 'SET_ACTIVE_COMPANY',
    payload: partner,
  });
};
